import React from 'react';

const ScanHistory = ({ scans, onSelectScan }) => {
  return (
    <div className="mt-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Historial de Escaneos</h3>
      <div className="space-y-2">
        {scans.map((scan) => (
          <div
            key={scan.id}
            onClick={() => onSelectScan(scan)}
            className="p-3 border border-gray-200 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
          >
            <div className="flex justify-between items-center">
              <span className="text-gray-700">Escaneo del {scan.date}</span>
              <span className="text-sm text-gray-500">{scan.documents.length} documentos</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ScanHistory;